import 'react-toastify/dist/ReactToastify.css'
import 'swiper/css/bundle'
import './firebase'
import './index.css'
import { Elements } from '@stripe/react-stripe-js'
import { GlobalContextProvider } from './Context/GlobalContext'
import React from 'react'
import ReactDOM from 'react-dom/client'
import RoutesApp from './Routes'
import { loadStripe } from '@stripe/stripe-js'
import { ToastContainer } from 'react-toastify'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

const stripePromise = loadStripe(process.env.REACT_APP_SPK)
export const queryClient = new QueryClient()

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <GlobalContextProvider>
        <Elements stripe={stripePromise}>
          <RoutesApp />
          <ToastContainer />
        </Elements>
      </GlobalContextProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)
